import * as Sentry from '@sentry/react';
import { useRouteError } from 'react-router-dom';
import { ERROR_BOUNDARIES, SENTRY_TAGS } from '~/shared/constants';

//TODO implement error page
const ErrorPage = () => {
  const error = useRouteError();

  if (error instanceof Error) {
    Sentry.captureException(error, {
      tags: {
        [SENTRY_TAGS.ERROR_BOUNDARY]: ERROR_BOUNDARIES.ROUTER_ERROR_PAGE,
      },
    });
  }

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>{error instanceof Error ? error.name : 'Unknown error'} </p>
    </div>
  );
};

export default ErrorPage;
